import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/model.png'


const _withScopeId = n => (_pushScopeId("data-v-1fc6063c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Lesson", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  width: "560",
  height: "315",
  src: "https://www.youtube.com/embed/aLfnP9StAMg",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  allowfullscreen: ""
}, "\n    ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "red" }, "Erratum", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To avoid any confusion between our parallel symbol \"||\" with an \"or\" symbol from Python, we are using the symbol \"//\".", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Summary", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Tutorials", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Translate these microgestures with µGlyph to train yourself.", -1))

import TutorialRow from '@/components/Lesson/TutorialRow.vue'


export default {
  __name: 'LessonView',
  setup(__props) {

const touch = {
  type: 'glyph',
  action: 'Flexion',
  context: ['Air', 'Contact'],
  actuator: [['thumb']],
  phalanx: [],
  contact: { actuator: [], phalanx: [], action: 'Contact' }
}

const drag = {
  type: 'or',
  operands: [
    {
      type: 'glyph',
      action: 'Flexion',
      context: ['Contact', 'Contact'],
      actuator: [['thumb']],
      phalanx: [],
      contact: {
        actuator: [['ring']],
        phalanx: [],
        action: 'Contact'
      }
    }, {
      type: 'glyph',
      context: ['Contact', 'Contact'],
      action: 'Extension',
      actuator: [['thumb']],
      phalanx: [],
      contact: {
        actuator: [['ring']],
        phalanx: [],
        action: 'Contact'
      }
    }]
}

const flex = {
  type: 'glyph',
  action: 'Flexion',
  context: ['Air', 'Air'],
  parameters: {
    pressure: { start: null, end: null, type: 'no_end' },
    amplitude: { start: 'op', end: 'ha', type: 'end' },
    time: { start: null, end: null, leftType: 'none', rightType: 'bigger' }
  },
  actuator: [['index']],
  phalanx: []
}

const extension = {
  type: 'seq',
  quantificators: { x: [[['index'], ['middle']]] },
  seq: {
    type: 'then',
    operands: [
      {
        type: 'glyph',
        context: ['Air', 'Air'],
        action: 'Extension',
        actuator: [['x']],
        phalanx: []
      },
      {
        type: 'glyph',
        context: ['Air', 'Contact'],
        action: 'Flexion',
        actuator: [['x']],
        phalanx: [],
        contact: { actuator: [['thumb']], phalanx: [], action: 'Contact' }
      }]
  }
}

const press = {
  type: 'glyph',
  context: ['Contact'],
  action: 'Flexion',
  parameters: {
    pressure: { start: 'lo', end: 'hi', type: 'end' },
    amplitude: { start: null, end: null, type: 'no_end' },
    time: { start: null, end: null, leftType: 'none', rightType: 'bigger' }
  },
  actuator: [['thumb', 'index', 'middle', 'ring', 'pinky']],
  phalanx: [],
  contact: { actuator: [], phalanx: [], action: 'Object' }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _createVNode(TutorialRow, {
      topic: "Touch with the thumb",
      microgesture: touch,
      comment: "Be carefull, when the thumb touches a finger it is not going up to the finger, it is going down to the palm thus the flexion symbol."
    }),
    _createVNode(TutorialRow, {
      topic: "Drag up or down of the thumb on the ring finger",
      microgesture: drag
    }),
    _createVNode(TutorialRow, {
      topic: "Flexion of the index finger until mid-closure",
      microgesture: flex
    }),
    _createVNode(TutorialRow, {
      topic: "Extension followed by a touch on the thumb with either the index or the middle finger",
      microgesture: extension,
      comment: "Be carefull that, in concise µGlyph, you need to specify a variable if you want to apply a choice from one event to the others"
    }),
    _createVNode(TutorialRow, {
      topic: "Squeeze of every finger on an object",
      microgesture: press
    })
  ]))
}
}

}